import React, { FC } from 'react'
import { Redirect, Route, Switch } from 'react-router-dom'

import ExportTables from 'components_new/pages/ExportTables'
import ExportTable from 'components_new/pages/ExportTable'

import { useIsAuthenticated } from 'redux/hooks/SignedInAccount'

import AuthRoute from './AuthRoute'

const Routes: FC = () => {
  const isAuthenticated = useIsAuthenticated()

  return (
    <Switch>
      <AuthRoute
        isAuthenticated={isAuthenticated}
        Component={() => <ExportTable />}
        path={'/export-tables/:id'}
      />
      <AuthRoute
        isAuthenticated={isAuthenticated}
        Component={() => <ExportTables />}
        path={'/export-tables'}
      />
      <Route path={'/export-tables/*'}>
        <Redirect to="/export-tables" />
      </Route>
    </Switch>
  )
}

export default Routes
